import type { FC, PropsWithChildren } from 'react';
import cls from 'classnames';
import './title.scss';

type Props = {
  size: 1 | 2 | 3;
  color: 1 | 2 | 3;
  className?: string;
};

const sizes = {
  1: 'titleSizeMain',
  2: 'titleSizeNormal',
  3: 'titleSizeSmall'
};

const colors = {
  1: 'titleColor1',
  2: 'titleColor2',
  3: 'titleColor3'
};

const ComponentTitle: FC<PropsWithChildren<Props>> = ({ size, color, className, children }) => {
  if (size === 1) return <h1 className={cls(className, sizes[size], colors[color])}>{children}</h1>;

  if (size === 2) return <h2 className={cls(className, sizes[size], colors[color])}>{children}</h2>;

  return <h3 className={cls(className, sizes[size], colors[color])}>{children}</h3>;
};

export default ComponentTitle;
